(function(){
  'use strict';
  function initGallery(gallery){
    if(!gallery || gallery.dataset.llDawnReady) return;
    gallery.dataset.llDawnReady='1';
    var main=gallery.querySelector('img.engoj_img_main');
    var items=Array.prototype.slice.call(gallery.querySelectorAll('.engoj-nav-item'));
    if(!main || !items.length) return;
    var current=Math.max(0,items.findIndex(function(li){return li.classList.contains('active');}));
    function select(i){
      if(!items.length) return;
      current=(i+items.length)%items.length;
      items.forEach(function(li,n){li.classList.toggle('active',n===current);});
      var btn=items[current].querySelector('[data-ll-gallery-src]');
      var src=btn&&btn.getAttribute('data-ll-gallery-src');
      if(src){main.src=src; main.removeAttribute('srcset');}
      items[current].scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
    }
    items.forEach(function(li,i){var b=li.querySelector('[data-ll-gallery-src]');if(b)b.addEventListener('click',function(){select(i);});});
    var prev=gallery.querySelector('.ll-dawn-gallery-arrow.prev');
    var next=gallery.querySelector('.ll-dawn-gallery-arrow.next');
    if(prev)prev.addEventListener('click',function(){select(current-1);});
    if(next)next.addEventListener('click',function(){select(current+1);});
  }
  function init(){
    if(document.querySelector('[data-ll-configurator], [data-ll-accessory-configurator]')){
      document.body.classList.add('ll-dawn-personalized-pdp','product');
      document.querySelectorAll('.ll-configurator-media .detail-gallery').forEach(initGallery);
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

(function(){
  'use strict';
  if(!document.querySelector('cart-items')) return;
  function esc(v){return window.CSS&&CSS.escape?CSS.escape(String(v)):String(v).replace(/"/g,'\\"');}
  document.addEventListener('change',function(e){
    var main=e.target&&e.target.closest&&e.target.closest('[data-ll-cart-main-qty]');
    if(!main)return; var g=main.getAttribute('data-ll-cart-main-qty'); if(!g)return;
    document.querySelectorAll('[data-ll-cart-addon-qty="'+esc(g)+'"]').forEach(function(x){x.value=main.value;});
  });
  document.addEventListener('click',function(e){
    var link=e.target&&e.target.closest&&e.target.closest('[data-ll-cart-remove-group]');
    if(!link)return; var g=link.getAttribute('data-ll-cart-remove-group'); if(!g)return;
    var rows=[].slice.call(document.querySelectorAll('[data-ll-cart-group="'+esc(g)+'"]'));
    var keys=rows.map(function(r){var q=r.querySelector('[data-quantity-line-key]');return q&&q.getAttribute('data-quantity-line-key');}).filter(Boolean);
    if(keys.length<2)return; e.preventDefault();e.stopPropagation();
    Promise.all(keys.map(function(key){return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:0})});})).then(function(){location.reload();});
  },true);
})();


/* Stage 7: remove orphaned paid-helper lines left behind after their parent crystal is removed. */
(function llCleanOrphanCartHelpers(){
  if (window.__llOrphanCartCleanupStarted) return;
  window.__llOrphanCartCleanupStarted = true;

  function helperType(item){
    var p=(item&&item.properties)||{};
    return String(p._addon_type||'').toLowerCase();
  }
  function groupId(item){
    var p=(item&&item.properties)||{};
    return String(p._customization_id||'');
  }
  fetch('/cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}})
    .then(function(r){return r.ok?r.json():Promise.reject();})
    .then(function(cart){
      if(!cart||!Array.isArray(cart.items)) return;
      var parentGroups={};
      cart.items.forEach(function(item){
        var t=helperType(item), g=groupId(item);
        if(g && t!=='service' && t!=='lightbase' && t!=='customized_accessory') parentGroups[g]=true;
      });
      var updates={};
      cart.items.forEach(function(item){
        var t=helperType(item), g=groupId(item);
        if((t==='service'||t==='lightbase') && (!g || !parentGroups[g])) updates[item.key]=0;
      });
      if(!Object.keys(updates).length) return;
      return fetch('/cart/update.js',{
        method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({updates:updates})
      }).then(function(r){return r.ok?r.json():Promise.reject();}).then(function(){
        var bubble=document.getElementById('cart-icon-bubble');
        if(bubble){
          var badge=bubble.querySelector('.cart-count-bubble');
          if(badge) badge.remove();
        }
      });
    }).catch(function(){});
})();

/* Stage 25: on phones, products should appear before the large review carousel.
   Keep the approved desktop order unchanged. */
(function llMobileHomeReviewsAfterProducts(){
  'use strict';

  var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

  function sectionFor(selector){
    var node = document.querySelector(selector);
    return node && node.closest ? node.closest('.shopify-section') : null;
  }

  function applyOrder(){
    var reviews = sectionFor('.ll-reviews-bar');
    var products = sectionFor('.ll-home-crystals');
    if (!reviews || !products || reviews.parentNode !== products.parentNode) return;

    var parent = products.parentNode;
    if (mq && mq.matches) {
      /* Mobile: Hero -> products -> reviews -> remaining homepage content. */
      if (products.nextElementSibling !== reviews) {
        parent.insertBefore(reviews, products.nextSibling);
      }
    } else {
      /* Desktop: preserve the existing approved Hero -> reviews -> products order. */
      if (reviews.nextElementSibling !== products) {
        parent.insertBefore(reviews, products);
      }
    }
  }

  function init(){
    applyOrder();
    if (mq) {
      if (typeof mq.addEventListener === 'function') mq.addEventListener('change', applyOrder);
      else if (typeof mq.addListener === 'function') mq.addListener(applyOrder);
    }

    /* Theme editor can hot-reload either section without a full page refresh. */
    document.addEventListener('shopify:section:load', function(){ setTimeout(applyOrder, 0); });
    document.addEventListener('shopify:section:reorder', function(){ setTimeout(applyOrder, 0); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Stage 25: remove the floating WhatsApp/chat bubble from the lower-right corner of
   mobile personalized product pages. App embeds can inject classless wrappers or iframes,
   so this supplements the explicit WhatsApp selectors with a tightly-scoped corner check. */
(function llSuppressMobilePdpCornerChat(){
  'use strict';

  var MQ = '(max-width: 767px)';
  var KEYWORDS = /(whatsapp|wa\.me|api\.whatsapp|joinchat|chaty|ht-ctc|wa-chat|wa_chat|wachat|whatapp)/i;

  function active(){
    if (!window.matchMedia || !window.matchMedia(MQ).matches) return false;
    return !!document.querySelector('[data-ll-configurator], .ll-product-configurator-page');
  }

  function protectedNode(el){
    if (!el || !el.closest) return false;
    return !!el.closest('[data-ll-configurator], .ll-image-editor-modal, .ll-cfg-mobile-cart, .ll-mobile-sticky-preview, .ll-cfg-mobile-sticky-preview');
  }

  function hide(el){
    if (!el || !el.style || protectedNode(el)) return;
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
    try { el.setAttribute('aria-hidden', 'true'); } catch (e) {}
  }

  function descriptor(el){
    var parts = [];
    try {
      parts.push(el.id || '', typeof el.className === 'string' ? el.className : '');
      ['href','src','title','aria-label','name','data-testid'].forEach(function(attr){ parts.push(el.getAttribute(attr) || ''); });
      var img = el.querySelector && el.querySelector('img');
      if (img) parts.push(img.getAttribute('src') || '', img.getAttribute('alt') || '');
    } catch (e) {}
    return parts.join(' ');
  }

  function isLowerRightFloatingControl(el){
    if (!el || el.nodeType !== 1 || protectedNode(el)) return false;
    var cs, r;
    try { cs = window.getComputedStyle(el); r = el.getBoundingClientRect(); } catch (e) { return false; }
    if (!cs || cs.display === 'none' || cs.visibility === 'hidden' || cs.position !== 'fixed') return false;
    if (r.width < 34 || r.height < 34 || r.width > 150 || r.height > 150) return false;
    if (Math.abs(r.width - r.height) > 45) return false;
    if (r.right < window.innerWidth - 125) return false;
    if (r.bottom < window.innerHeight - 220) return false;

    /* Require a visual icon/button shape so ordinary fixed containers are not removed. */
    var visual = false;
    try {
      visual = !!el.querySelector('svg, img, button, [role="button"]');
      var radius = parseFloat(cs.borderTopLeftRadius || '0');
      if (radius >= Math.min(r.width, r.height) * 0.28) visual = true;
    } catch (e) {}
    return visual;
  }

  function inspectElement(el){
    if (!active() || !el || el.nodeType !== 1 || protectedNode(el)) return;

    if (KEYWORDS.test(descriptor(el))) {
      hide(el);
      return;
    }

    /* Known classless app iframe/host: only a small square-ish fixed control in the
       lower-right purchase-CTA zone qualifies. */
    if (isLowerRightFloatingControl(el)) hide(el);
  }

  function scan(root){
    if (!active()) return;
    var scope = root && root.querySelectorAll ? root : document;
    if (root && root.nodeType === 1) inspectElement(root);

    var selectors = [
      'iframe',
      'a[href*="wa.me" i]', 'a[href*="whatsapp" i]',
      '[class*="whatsapp" i]', '[id*="whatsapp" i]',
      '[class*="chaty" i]', '[id*="chaty" i]',
      '.joinchat', '#joinchat', '.ht-ctc-chat', '#ht-ctc-chat',
      '[style*="position: fixed" i]', '[style*="position:fixed" i]'
    ].join(',');

    try {
      Array.prototype.slice.call(scope.querySelectorAll(selectors)).forEach(inspectElement);
    } catch (e) {}

    /* Some app styles are applied through a stylesheet instead of inline style, so do a
       limited pass over direct body children where floating chat hosts are normally mounted. */
    if (scope === document && document.body) {
      Array.prototype.slice.call(document.body.children).forEach(inspectElement);
    }
  }

  function init(){
    if (!active()) return;
    scan(document);
    [250, 800, 1600, 3000, 5000].forEach(function(delay){ setTimeout(function(){ scan(document); }, delay); });

    if (window.MutationObserver && document.body) {
      var observer = new MutationObserver(function(records){
        if (!active()) return;
        records.forEach(function(record){
          Array.prototype.slice.call(record.addedNodes || []).forEach(function(node){
            if (!node || node.nodeType !== 1) return;
            scan(node);
            setTimeout(function(){ inspectElement(node); scan(node); }, 350);
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
